<template>   
    <div class="row order-items-component">
        <div class="col-12">
            <h3 class="mb-1">{{ title }}</h3>
            <span class="text-danger" v-if="errors['items'] !== undefined">{{ errors.items[0] }}</span>
        </div>
        <div class="col-12">
            <table class="table table-bordered table-striped" :id="table_id">
                <thead>
                    <tr>
                        <th v-for="header in headers" :key="header.key">
                            {{ header.trans }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, item_index) in items" :key="item_index" :row_index="item_index">
                        <input type="hidden" :name="'items['+item_index+'][good_id]'" v-model="item['good_id']" /> 
                        <td>
                            <!-- Good select / Title -->
                            <select 
                                v-if="headers[0]['type'] === 'select2_ajax'"
                                v-select2
                                :data-url="headers[0]['select2_url']"
                                @change="applySelect(item_index)"
                                :class="'form-control form-control-sm select2_ajax new_select2_ajax input_' + headers[0]['key']"                               
                                v-model="item[headers[0]['key']]"        
                            > 
                            </select>
                            <input type="text" 
                                v-else
                                :class="'form-control form-control-sm input_' + headers[0]['key']" 
                                :name="'items['+item_index+']['+headers[0]['key']+']'" 
                                v-model="item[headers[0]['key']]"
                            >
                            <span class="text-danger" v-if="errors['items.'+item_index+'.'+headers[0]['key']] !== undefined">
                                {{ errors['items.'+item_index+'.'+headers[0]['key']][0].replace('items.'+item_index+'.'+headers[0]['key'], headers[0]['trans']) }}
                            </span>
                        </td>
                        <td>
                            <!-- Count -->
                            <input type="number" 
                                :class="'form-control form-control-sm input_' + headers[1]['key']" 
                                :name="'items['+item_index+']['+headers[1]['key']+']'" 
                                v-model="item[headers[1]['key']]"
                                @input="calculateSum"
                            >
                            <span class="text-danger" v-if="errors['items.'+item_index+'.'+headers[1]['key']] !== undefined">
                                {{ errors['items.'+item_index+'.'+headers[1]['key']][0].replace('items.'+item_index+'.'+headers[1]['key'], headers[1]['trans']) }}
                            </span>
                        </td>
                        <td>
                            <!-- Unit Price -->
                            <input type="number" 
                                :class="'form-control form-control-sm input_' + headers[2]['key']" 
                                :name="'items['+item_index+']['+headers[2]['key']+']'" 
                                v-model="item[headers[2]['key']]"
                                @input="calculateSum"
                                readonly
                            >
                            <span class="text-danger" v-if="errors['items.'+item_index+'.'+headers[2]['key']] !== undefined">
                                {{ errors['items.'+item_index+'.'+headers[2]['key']][0].replace('items.'+item_index+'.'+headers[2]['key'], headers[2]['trans']) }}
                            </span>
                        </td>                        
                        <td>
                            <!-- Total -->
                            <input type="number" 
                                :class="'form-control form-control-sm input_' + headers[3]['key']" 
                                :name="'items['+item_index+']['+headers[3]['key']+']'"
                                v-model="item[headers[3]['key']]"
                                readonly
                            >
                        </td>
                        <td>
                            <!-- Notes -->
                            <input type="text" 
                                    :class="'form-control form-control-sm input_' + headers[4]['key']" 
                                    :name="'items['+item_index+']['+headers[4]['key']+']'" 
                                    v-model="item[headers[4]['key']]"                          
                            >
                        </td>
                        <td>
                            <!-- File upload -->
                            <input type="file" 
                                :class="'form-control form-control-sm input_' + headers[5]['key']" 
                                :name="'items['+item_index+']['+headers[5]['key']+']'"                                                         
                                
                            >
                        </td>
                        <td class="shrink-cell">
                            <!-- Actions -->
                            <button type="button" class="btn btn-danger btn-sm mt-1" @click="deleteRow">
                                <i class="fa fa-times"></i>
                            </button>                            
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-12">
            <button type="button" class="btn btn-primary btn-sm" @click="addNewRow();">
                <i class="fa fa-plus"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data: function(){
        return {
            'headers': [],
            'items': [],
            'errors': [],
        }
    },
    props: {
        'table_id': {
            'type': String,
            'required': true,
        },
        'headers_json': {
            'type': String,
            'required': true,
        },
        'items_json': {
            'type': String,
            'required': true,
        },
        'goods_map_json': {
            'type': String,
            'required': true,
        },
        'title': {
            'type': String,
            'required': true,
        },
        'errors_json': {
            'type': String,
            'required': true,
        },
    },
    created: function(){
        let vue = this;
        
        vue.headers = JSON.parse(Base64.decode(vue.headers_json));
        vue.items = JSON.parse(Base64.decode(vue.items_json));
        vue.goods_map = JSON.parse(Base64.decode(vue.goods_map_json));
        vue.errors = JSON.parse(Base64.decode(vue.errors_json));       
        vue.headers.push({'key': 'actions', 'value': ''});

        $.each(vue.items, function(index, element){
            vue.items[index]['total'] =  (parseFloat(vue.items[index]['unit_price']) * parseFloat(vue.items[index]['count'])).toFixed(2);
        });
    },
    mounted: function () {
        let vue = this;       

        $.each(vue.items, function(index, element){    
            $(`#${vue.table_id} tr[row_index=${index}] td .select2_ajax`).append( new Option(`${vue.goods_map[element.good_id]}`, element.good_id, true, true));
        });
    },
    updated: function () {
        this.$nextTick(function () {
            let new_select2_ajax = $('.new_select2_ajax');
            window.initSelect2Ajax(new_select2_ajax);
            new_select2_ajax.trigger('change').removeClass('new_select2_ajax');
        })
    },
    methods: {
        addNewRow: function(){
            let vue = this;

            let new_item = {};
            $.each(vue.headers, function(key, value){
                new_item[value.key] = '';
            });
            new_item['count'] = '1';
            new_item['unit_price'] = '';
            new_item['total'] = '';

            vue.items.push(new_item);
        },
        applySelect: function(item_index){
            let vue = this;

            let decoded_value = JSON.parse(Base64.decode(vue.items[item_index].item));

            vue.items[item_index]['good_id'] = decoded_value.id;
            vue.items[item_index]['unit_price'] = decoded_value.price;
            vue.items[item_index]['total'] = (parseFloat(vue.items[item_index]['unit_price']) * parseFloat(vue.items[item_index]['count'])).toFixed(2);
        },
        calculateSum: function(event){
            let vue = this;
            
            let item_index = $(event.target).parents('tr').first().attr('row_index');

            vue.items[item_index]['total'] = (parseFloat(vue.items[item_index]['unit_price']) * parseFloat(vue.items[item_index]['count'])).toFixed(2);
        },
        deleteRow: function(event){
            let vue = this;

            let item_index = $(event.target).parents('tr').first().attr('row_index');
            vue.items = vue.items.filter(function(value, index, array){
                return index != item_index;
            });
        },
    }
}
</script>
